module.exports = __webpack_public_path__ + "img/maidian1.2b055e3f.png";